// let processUrl = 0; //0 测试  1正式

// function setUrl() {
//     if (processUrl == 0) { //测试环境
//         var hrefUrl = 'https://hkmc-h5.verapay.cn/#/'; //测试环境域名
//         var richOpenapi = 'http://rich-openapi.verapay.cn/open-api/'; //正式环境api
//     } else { //正式环境
//         var hrefUrl = 'https://h5-share.jftpay.hkrt.cn/#/'; //正式环境域名
//         var richOpenapi = 'https://gateway.jftpay.hkrt.cn/open-api/'; //正式环境api
//     }
//     let obj = {}
//     obj.hrefUrl = hrefUrl;
//     obj.richOpenapi = richOpenapi;
//     return obj;
// }
// export default {
//     setUrl
// }

function setUrl() {
    // let hrefUrl = "";
    // let richOpenapi = "";

    // if (process.env.NODE_ENV === 'production') { // 正式环境
    //     // hrefUrl = 'http://101.52.127.100/hkmc-h5/#/'; //正式环境IP
    //     hrefUrl = 'https://hkmc-h5.hkrt.cn/hkmc-h5/#/'; //正式环境域名

    //     // richOpenapi = 'http://101.52.127.100/center-gateway/center-app/app-api/'; //正式环境api
    //     richOpenapi = 'https://gateway.jftpay.hkrt.cn/app-api/'; //海科正式-新-处理后
    // } else { // 测试环境
    //     hrefUrl = 'http://101.52.141.93/hkmc-h5-sit/#/';

    //     // richOpenapi = 'http://172.16.27.8:12080/center-app/app-api/';
    //     richOpenapi = 'http://101.52.141.93:12080/center-app/app-api/';
    // }

    let hrefUrl = process.env.VUE_APP_HREF_URL
    let richOpenapi = process.env.VUE_APP_RICH_OPEN_API

    let obj = {}
    obj.hrefUrl = hrefUrl;
    obj.richOpenapi = richOpenapi;
    return obj;
}
export default {
    setUrl
}
